import axios from "axios";
import { API_BASE_URL } from "../../../config";

export async function fetchAdminReferralDesk({
  page,
  limit,
  desk,
  status,
  search,
  sort,
  refresh,
} = {}) {
  const token = localStorage.getItem("adminToken");
  const params = new URLSearchParams();

  if (page) params.set("page", String(page));
  if (limit) params.set("limit", String(limit));
  if (desk) params.set("desk", desk);
  if (status && status !== "all") params.set("status", status);
  if (search) params.set("search", search);
  if (sort) params.set("sort", sort);
  if (refresh) params.set("refresh", "1");

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/referrals?${params.toString()}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}

export async function fetchAdminReferralDetail(referralId, { refresh } = {}) {
  const token = localStorage.getItem("adminToken");
  const params = refresh ? "?refresh=1" : "";
  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/referrals/${referralId}${params}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}
